import React, { useEffect, useState } from "react";
import {Button} from "grommet";
import {DownloadOption} from "grommet-icons";


const InstallPWA = () => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);

    useEffect(() => {
        const handler = e => {
            e.preventDefault();
            console.log("we are being triggered :D");
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    const onClick = evt => {
        evt.preventDefault();
        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    };
    if (!supportsPWA) {
        return null;
    }
    return (
        <Button
            icon={<DownloadOption color="plain"/>}
            hoverIndicator
            alignSelf={"center"}
            className="link-button"
            id="setup_button"
            label="Download app"
            title="Download app"
            onClick={onClick}
            secondary
        >
        </Button>
    );
};

export default InstallPWA;